/**
 * «← Процессы / Новый процесс / …» — шапка подстраниц /processes/*. Последний пункт — текущая
 * страница (без ссылки); остальные ведут по своему href (navigate: вернуться, а не плодить историю).
 */
import { Fragment } from 'react'
import { useRouter, type Href } from 'expo-router'
import { Text, XStack } from 'tamagui'

import { useApp } from '../../../i18n'
import { Icon } from '../../../ui'
import { pressable } from '../../../ui/primitives'

export function Breadcrumb({ items }: { items: { label: string; href?: Href }[] }) {
  const { l } = useApp()
  const router = useRouter()
  return (
    <XStack role="navigation" aria-label={l('proc.breadcrumb')} alignItems="center" gap={6} flexWrap="wrap">
      {items.map((it, i) => (
        <Fragment key={i}>
          {i > 0 ? (
            <Text fontSize={13} color="$tertiary">
              /
            </Text>
          ) : null}
          {it.href ? (
            <XStack
              {...pressable}
              role="link"
              onPress={() => router.navigate(it.href!)}
              cursor="pointer"
              alignItems="center"
              gap={6}
              minHeight={36}
              hoverStyle={{ opacity: 0.8 }}
            >
              {i === 0 ? <Icon name="arrow-left" size={16} color="$primary" /> : null}
              <Text fontSize={13} fontWeight="600" color="$primary">
                {it.label}
              </Text>
            </XStack>
          ) : (
            <Text fontSize={13} color="$muted" numberOfLines={1} aria-current="page">
              {it.label}
            </Text>
          )}
        </Fragment>
      ))}
    </XStack>
  )
}
